<template>
    <div class="c-o-search-sidebar c-o-search-sidebar--mobile">
        <div v-if="$mq === 'xSmall' || $mq === 'small' || $mq === 'medium'" class="c-o-search-sidebar__toggle-wrapper">
            <p class="c-o-search-sidebar__toggle-heading">{{activeFilters}}</p>
            <atom-button
                class="c-o-search-sidebar__toggle"
                :modifiers="'c-a-button--theme-primary '"
                :label="filterToggled ? 'Dölj alla filter' : 'Visa alla filter'"
                :icon="'expand_more'"
                :class="{'c-o-search-sidebar__toggle--toggled' : filterToggled}"
                @buttonClicked="toggleFilter">
            </atom-button>
        </div>
        <div v-show="filterToggled || $mq === 'large' || $mq === 'xLarge'" class="c-o-search-sidebar__inner">
            <div class="c-o-search-sidebar__block">
                <geo-location-search
                    :label="'Kommun'"
                    :placeholder="'Ex. Uppsala'"
                    :categorieIsSet="categoryModel !== null ? true : false"
                    v-model="regionModel"
                ></geo-location-search>
            </div>
            <div class="c-o-search-sidebar__block">
                <drilldown
                    :items="categories"
                    :defaultValue="searchParams.categories"
                    :label="'Kategori'"
                    :placeholder="'Sök efter en kategori'"
                    v-model="categoryModel"
                ></drilldown>
            </div>
        </div>
        
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import {
        FETCH_REQUESTS,
        SET_CATEGORY_ACTION,
        SET_REGION_ACTION,
        GET_REQUESTS,
        GET_SEARCH_PARAMS,
        IS_LOADING,
        GET_ERROR }
        from '../../../../store/store-models/requests-model';

    import { FETCH_FILTERS, GET_CATEGORIES, GET_REGIONS } from '../../../../store/store-models/filters-model';

    import AtomButton from '../../atoms/AtomButton.vue'
    import AtomSelect from '../../atoms/form/AtomSelect.vue'
    import Drilldown from '../../atoms/form/AtomDrilldownCategoriesSearch.vue'
    import GeoLocationSearch from '../../atoms/form/AtomInputAutocompleteRegion.vue'

    export default {
        components: {
            AtomButton,
            AtomSelect,
            Drilldown,
            GeoLocationSearch,
        },
        data() {
            return {
                filterToggled: false,
            }
        },
        computed: {
            ...mapGetters({
                requests: GET_REQUESTS,
                searchParams: GET_SEARCH_PARAMS,
                isLoading: IS_LOADING,
                error: GET_ERROR,
                regions: GET_REGIONS,
                categories: GET_CATEGORIES,
            }),
            nrOfRequests: function() {
                return !this.isLoading ? this.requests.meta.count : 0
            },
            activeFilters: function() {
                let chosenRegion = this.searchParams.region;
                let chosenCategory = this.searchParams.category;

                const filterArr = [chosenRegion, chosenCategory];
                let activeItems = [];
                activeItems = filterArr.filter(filter => {
                    return filter ? true : false
                });

                if (activeItems.length === 1) {
                    return `${activeItems.length} filter aktivt`
                } else {
                    return `${activeItems.length} filter aktiva`
                }
            },
            regionModel: {
                get: function() {
                    return this.searchParams.region
                },
                set: function(val) {
                    if (val) {
                        this.setRegion(val);
                    } else {
                        this.setRegion(null);
                    }
                    this.fetchRequests();
                }
            },
            categoryModel: {
                get: function() {
                    return this.searchParams.category
                },
                set: function(val) {
                    this.setCategory(val);
                    this.fetchRequests();
                }
            }
        },
        methods: {
            ...mapActions({
                fetchRequests: FETCH_REQUESTS,
                fetchFilters: FETCH_FILTERS,
                setRegion: SET_REGION_ACTION,
                setCategory: SET_CATEGORY_ACTION,
            }),
            toggleFilter(){
                if (this.filterToggled === true) {
                    this.filterToggled = false
                } else {
                    this.filterToggled = true
                }
            },
        },
        created() {
            this.fetchFilters();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/search/OrganismSearchSidebarRequests.vue